module.exports = __webpack_public_path__ + "img/api-management-platforms-mobile.4fb3e621.svg";